/**
 * Ported from plm/portal/ui/lib/quickTests/web/legacy/ColorSelector.js
 * No jQuery usage in original; converted CommonJS module.exports to ESM default export.
 *
 * ColorSelector is a JS Object that returns a color for a particular traceroute 'node' based
 * on whether it is a common ASN. It will always return the same color for a common ASN such as
 * any of Amazon's, but for lesser ASNs it will select a new color and associate that color
 * with the ASN for 1 instance of a traceroute visualization.
 */

function ColorSelector() {
    const dictionary = {}; // used to store ASN-color pairs

    const store = function store(key, value) {
        dictionary[key] = value;
    };

    const retrieve = function retrieve(key) {
        return dictionary[key];
    };

    const COMMON_ASN_INFO = {
        15169: { name: 'Google', color: '#4bbaf2;' },
        14618: { name: 'Amazon', color: '#fcf005;' },
        16509: { name: 'Amazon', color: '#fcf005;' },
        38895: { name: 'Amazon', color: '#fcf005;' },
        13414: { name: 'Twitter', color: '#55acee;' },
        32934: { name: 'Facebook', color: '#3b5999;' },
        4323: { name: 'TW Telecom', color: '#FD5622;' },
        16435: { name: 'Fluke', color: '#F6AC29;' },
        3356: { name: 'Level 3', color: '#D70101;' },
        3549: { name: 'Level 3', color: '#D70101;' },
        14340: { name: 'Salesforce.com', color: '#A6D5EB;' },
        18821: { name: 'CenturyLink', color: '#9ACD57;' },
        209: { name: 'Qwest/CentruyLink', color: '#9ACD57;' },
        2828: { name: 'XO', color: '#843C97;' },
        174: { name: 'Cogent Comm', color: '#C8E1F2;' },
        3257: { name: 'Tinet SpA', color: '#109D8A;' },
        1299: { name: 'TeliaSonera', color: '#652D86;' },
        2914: { name: 'NTT America', color: '#09266C;' },
        6453: { name: 'Tata', color: '#0173BA;' },
        6762: { name: 'Italia Sparkle', color: '#EB404D;' },
        6939: { name: 'Hurricane Elec', color: '#000066;' },
        1273: { name: 'Cable and Wireless', color: '#0071C1;' },
        7018: { name: 'AT&T', color: '#2E8AB4;' },
        701: { name: 'Verizon', color: '#EE1A29;' },
        3320: { name: 'Deutsche Telekom', color: '#DD0270;' },
        3491: { name: 'Beyond the Network', color: '#00498F;' },
        1239: { name: 'Sprint', color: '#FFE100;' },
        6461: { name: 'Abovenet Comm', color: '#0199CB;' },
        9002: { name: 'RETN Limited', color: '#CB0B83;' },
        2516: { name: 'KDDI Corp', color: '#100F6A' },
    };

    const colors = [
        '#006600',
        '#006666',
        '#006699',
        '#0066FF',
        '#00CC99',
        '#00CCCC',
        '#660033',
        '#660066',
        '#660099',
        '#6600CC',
        '#990033',
        '#990066',
        '#9966CC',
        'FF9933',
        '#FF6666',
        '#FFCC66',
        '#566D7E',
        '#728C00',
        '#FFD801',
        '#FBB117',
        '#C68E17',
    ];

    let index = 0;

    const nextColor = function nextColor() {
        const color = colors[index];
        index += 1;
        return color;
    };

    this.getColorFor = function getColorFor(key) {
        let color;
        if (COMMON_ASN_INFO[key]) {
            color = COMMON_ASN_INFO[key].color;
        } else {
            color = retrieve(key);
            if (!color) {
                color = nextColor();
                store(key, color);
            }
        }
        return color;
    };
}

export default ColorSelector;
